import { render, staticRenderFns } from "./IdeaOverview.vue?vue&type=template&id=5344a54d&"
import script from "./IdeaOverview.vue?vue&type=script&lang=js&"
export * from "./IdeaOverview.vue?vue&type=script&lang=js&"
import style0 from "./IdeaOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports